import { render, staticRenderFns } from "./DisputeGridView.vue?vue&type=template&id=aa304cfe&scoped=true"
import script from "./DisputeGridView.vue?vue&type=script&lang=js"
export * from "./DisputeGridView.vue?vue&type=script&lang=js"
import style0 from "./DisputeGridView.vue?vue&type=style&index=0&id=aa304cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa304cfe",
  null
  
)

export default component.exports